<template>
	<v-container grid-list-md>
		<v-card>
			<v-card-title>
				<v-card-title primary-title>
					<v-btn
						icon
						@click="$inertia.visit($route('central.tenants.index'))"
						><v-icon>mdi-arrow-left</v-icon></v-btn
					>
					{{ $t("title.show_tenant") }}
				</v-card-title>
			</v-card-title>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs12 md9>
						<v-card>
							<v-container>
								<h2 class="pt-1 ml-6">
									{{ $t("label.information_tenant") }}
								</h2>
								<v-row>
									<v-col cols="12" sm="6" md="6">
										<v-flex xs12 md11>
											<p class="text-caption ml-5 pt-5">
												{{ $t("Name") }}
											</p>
											<v-btn
												disabled
												block
												class="font-weight-black ml-5"
												>{{ tenant.name }}
											</v-btn>
										</v-flex>
									</v-col>
									<v-col cols="12" sm="6" md="6">
										<v-flex xs12 md11>
											<p class="text-caption ml-5 pt-5">
												{{ $t("Code") }}
											</p>
											<v-btn
												disabled
												block
												class="font-weight-black ml-5"
												>{{ tenant.code }}
											</v-btn>
										</v-flex>
									</v-col>
									<v-col cols="12" sm="6" md="6">
										<v-flex xs12 md11>
											<p class="text-caption ml-5">
												{{ $t("label.order") }}
											</p>
											<v-btn
												disabled
												block
												class="font-weight-black ml-5"
												>{{ tenant.order }}
											</v-btn>
										</v-flex>
									</v-col>
									<v-col cols="12" sm="6" md="6">
										<v-flex xs12 md11>
											<p class="text-caption ml-5">
												{{ $t("label.cuisines") }}
											</p>
											<v-btn
												disabled
												block
												class="font-weight-black ml-5"
												>{{ tenant.cuisines }}
											</v-btn>
										</v-flex>
									</v-col>
									<v-col cols="12" sm="6" md="6">
										<v-flex xs12 md11>
											<p class="text-caption ml-5">
												{{ $t("label.experience") }}
											</p>
											<v-btn
												disabled
												block
												class="font-weight-black ml-5"
												>{{ tenant.experience }}
											</v-btn>
										</v-flex>
									</v-col>
									<v-col cols="12" sm="6" md="6">
										<v-flex xs12 md11>
											<p class="text-caption ml-5">
												{{ $t("label.price_level") }}
											</p>
											<v-btn
												disabled
												block
												class="font-weight-black ml-5"
												>{{ tenant.price_level }}
											</v-btn>
										</v-flex>
									</v-col>
								</v-row>
							</v-container>
						</v-card>
					</v-flex>
					<v-flex xs12 md3>
						<v-card class="max-width:200px min-height: 200px">
							<v-container>
								<h2 class="ml-6">
									{{ $t("label.image") }}
								</h2>
								<v-img
									:src="
										tenant
											? tenant.image_url
											: '/images/image_placeholder.jpg'
									"
									style="h-1, min-w-1"
								></v-img>
							</v-container>
						</v-card>
					</v-flex>
				</v-layout>
			</v-card-text>
		</v-card>
	</v-container>
</template>
<script>
export default {
	props: ["tenant"],
	data() {
		return {
			selectedItem: 0,
		};
	},
};
</script>